const TreatmentPriceCell = ({ renderPriceEditInputCell, renderPriceCell }) => ({
    field: 'price',
    headerName: 'Price',
    sortable: false,
    width: 110,
    minWidth: 90,
    editable: true,
    renderEditCell: renderPriceEditInputCell,
    renderCell: renderPriceCell,
});

export default TreatmentPriceCell;